// 列表组件需要的数据
export const fromList = [
  {
    label: '参评人',
    required: true,
    placeholder: '请输入参评人姓名',
    tip: '请输入参评人(15字以内)',
    type: 'input',
    value: undefined,
    key: 'name',
    reg: null,
    maxLength: 15,
  },
  {
    label: '性别',
    required: true,
    placeholder: '',
    tip: '',
    type: 'radio',
    value: '男',
    key: 'sex',
    reg: null,
    maxLength: null,
    options: [
      { label: '男', value: '男' },
      { label: '女', value: '女' },
    ],
  },
  {
    label: '年龄',
    required: true,
    placeholder: '请输入参评人年龄',
    tip: '请输入参评人年龄（2位整数）',
    type: 'input',
    value: undefined,
    key: 'year',
    reg: /^[1-9]\d$/,
    maxLength: 2,
  },
  {
    label: '政治面貌',
    required: true,
    placeholder: '请选择政治面貌',
    tip: '请选择政治面貌',
    type: 'select',
    value: undefined,
    key: 'political',
    reg: null,
    maxLength: null,
    options: [
      '中共党员',
      '民革党员',
      '民盟盟员',
      '民建会员',
      '民进会员',
      '农工党党员',
      '致公党党员',
      '九三学社社员',
      '台盟盟员',
      '群众',
    ],
  },
  {
    label: '学历',
    required: true,
    placeholder: '请选择学历',
    tip: '请选择学历',
    type: 'select',
    value: undefined,
    key: 'education',
    reg: null,
    maxLength: null,
    options: ['选项有专科', '本科', '硕士研究生', '博士研究生', '其他'],
  },
  {
    label: '学位',
    required: true,
    placeholder: '请选择学位',
    tip: '请选择学位',
    type: 'select',
    value: undefined,
    key: 'educationposition',
    reg: null,
    maxLength: null,
    options: ['学士', '硕士', '博士', '其他'],
  },
  {
    label: '证件类型',
    required: true,
    placeholder: '请选择证件类型',
    tip: '请选择证件类型',
    type: 'select',
    value: '身份证',
    key: 'idType',
    reg: null,
    maxLength: null,
    options: ['身份证'],
  },
  {
    label: '证件号码',
    required: true,
    placeholder: '请输入证件号码',
    tip: '请输入证件号码',
    type: 'input',
    value: null,
    key: 'idNumber',
    reg: null,
    maxLength: null,
  },
  {
    label: '参评人企业',
    required: true,
    placeholder: '请输入参评人企业标准全称',
    tip: '请输入参评人企业标准全称(50字以内)',
    type: 'input',
    value: null,
    key: 'company',
    reg: null,
    maxLength: 50,
  },
  {
    label: '职务',
    required: true,
    placeholder: '请输入参评人职务',
    tip: '请输入参评人职务(50字以内)',
    type: 'input',
    value: null,
    key: 'job',
    reg: null,
    maxLength: 50,
  },
  {
    label: '推荐单位',
    required: false,
    placeholder: '请输入推荐单位名称（选填）',
    tip: '请输入推荐单位(50字以内)',
    type: 'input',
    value: null,
    key: 'recommend',
    reg: null,
    maxLength: 50,
  },
  {
    label: '手机',
    required: true,
    placeholder: '请输入手机号',
    tip: '手机号不正确',
    type: 'input',
    value: null,
    key: 'phone',
    reg: /^1[345789][0-9]{9}$/,
    maxLength: 11,
  },
  {
    label: '社会头衔',
    required: false,
    placeholder: '请输入社会头衔（选填）',
    tip: '请输入社会头衔(50字以内)',
    type: 'input',
    value: null,
    key: 'titles',
    reg: null,
    maxLength: 50,
  },
  {
    label: '人才称号、个人荣誉',
    required: false,
    placeholder: '仅填写国家级、省市级荣誉，选填',
    tip: '人才称号、个人荣誉(50字以内)',
    type: 'input',
    value: null,
    key: 'talent',
    reg: null,
    maxLength: 50,
  },
  {
    label: '个人简历',
    required: true,
    placeholder: '包括学习和工作经历',
    tip: '请输入个人简历（包括学习和工作经历）',
    type: 'textarea',
    value: null,
    key: 'content',
    reg: null,
    maxLength: null,
  },
  {
    label: '纳税人识别号',
    required: true,
    placeholder: '请输入纳税人识别号',
    tip: '请请输入纳税人识别号',
    type: 'input',
    value: null,
    key: 'taxpayer',
    reg: null,
    maxLength: 100,
  },
  {
    label: '单位性质',
    required: true,
    placeholder: '请选择单位性质',
    tip: '请选择单位性质',
    type: 'select',
    value: undefined,
    key: 'nature',
    reg: null,
    maxLength: null,
    options: [
      '民营企业',
      '国有企业',
      '集体企业',
      '公私合作企业',
      '中外合资企业',
      '外商独资企业',
      '非盈利组织',
    ],
  },
  {
    label: '行业',
    required: true,
    placeholder: '请选择单位所属行业',
    tip: '请选择单位所属行业',
    type: 'select',
    value: undefined,
    key: 'industry',
    reg: null,
    maxLength: null,
    options: [
      '农、林、牧、渔业',
      '采矿业',
      '制造业',
      '电力、燃气及水的生产和供应业',
      '建筑业',
      '信息传输、计算机服务和软件业',
      '批发和零售业',
      '住宿和餐饮业',
      '金融业',
      '房地产业',
      '租赁和商务服务业',
      '科学研究、技术服务和地质勘查业',
      '水利、环境和公共设施管理业',
      '居民服务和其他服务业',
      '教育',
      '卫生、社会保障和社会福利业',
      '文化、体育和娱乐业',
      '其他',
    ],
  },
  {
    label: '是否上市公司',
    required: true,
    placeholder: '',
    tip: '',
    type: 'radio',
    value: '是',
    key: 'public',
    reg: null,
    maxLength: null,
    options: [
      { label: '是', value: '是' },
      { label: '否', value: '否' },
    ],
  },
  {
    label: '股票代码',
    required: false,
    placeholder: '请输入公司股票代码',
    tip: '请请输入公司股票代码',
    type: 'input',
    value: null,
    key: 'onsaleSign',
    reg: null,
    maxLength: null,
  },
  {
    label: '高新技术企业认定 ',
    required: true,
    placeholder: '请选择高新技术企业认定',
    tip: '请选择高新技术企业认定',
    type: 'select',
    value: undefined,
    key: 'cognizance',
    reg: null,
    maxLength: null,
    options: ['国家高新技术企业', '重庆市高新技术企业', '无'],
  },
  {
    label: '企业资产(万元)',
    required: true,
    placeholder: '请输入企业总资产',
    tip: '请输入企业总资产，可保留两位小数',
    type: 'input',
    value: null,
    key: 'assets',
    reg: /^(-)?\d+(\.\d{0,2})?$/,
    maxLength: null,
  },
  {
    label: '净资产回报率（%）',
    required: true,
    placeholder: '请输入净资产回报率',
    tip: '请输入净资产回报率，可保留两位小数',
    type: 'input',
    value: null,
    key: 'return_rate',
    reg: /^(-)?\d+(\.\d{0,2})?$/,
    maxLength: null,
  },
  {
    label: '资产负债率（%）',
    required: true,
    placeholder: '请输入资产负债率',
    tip: '请输入资产负债率，可保留两位小数',
    type: 'input',
    value: null,
    key: 'debt_ratio',
    reg: /^(-)?\d+(\.\d{0,2})?$/,
    maxLength: null,
  },
  {
    label: '2025年度营业收入(万元)',
    required: true,
    placeholder: '请输入年度营业收入',
    tip: '请输入2025年度营业收入(万元)，可保留两位小数',
    type: 'input',
    value: null,
    key: 'turnover',
    reg: /^(-)?\d+(\.\d{0,2})?$/,
    maxLength: null,
  },
  {
    label: '2025年度营收增加值(万元)',
    required: true,
    placeholder: '与2024年相比',
    tip: '2025年度营收增加值(万元)，可保留两位小数',
    type: 'input',
    value: null,
    key: 'turnover_increase',
    reg: /^(-)?\d+(\.\d{0,2})?$/,
    maxLength: null,
  },
  {
    label: '2025年度纳税额(万元)',
    required: true,
    placeholder: '请输入年度纳税总额',
    tip: '2025年度纳税额(万元)，可保留两位小数',
    type: 'input',
    value: null,
    key: 'taxes',
    reg: /^(-)?\d+(\.\d{0,2})?$/,
    maxLength: null,
  },
  {
    label: '2025年度税率(%)',
    required: true,
    placeholder: '请输入年度税率',
    tip: '2025年度税率(%)，可保留两位小数',
    type: 'input',
    value: null,
    key: 'taxes_increase',
    reg: /^(-)?\d+(\.\d{0,2})?$/,
    maxLength: null,
  },
  {
    label: '2025年度利润额(万元)',
    required: true,
    placeholder: '请输入年度税后利润',
    tip: '2025年度利润额(万元)，可保留两位小数',
    type: 'input',
    value: null,
    key: 'profit',
    reg: /^(-)?\d+(\.\d{0,2})?$/,
    maxLength: null,
  },
  {
    label: '2025年度利润率(%)',
    required: true,
    placeholder: '请输入年度利润率',
    tip: '2025年度利润率(%)，可保留两位小数',
    type: 'input',
    value: null,
    key: 'profit_increase',
    reg: /^(-)?\d+(\.\d{0,2})?$/,
    maxLength: null,
  },
  {
    label: '研发经费(万元)',
    required: true,
    placeholder: '请输入研发经费',
    tip: '研发经费(万元)，可保留两位小数',
    type: 'input',
    value: null,
    key: 'funds',
    reg: /^(-)?\d+(\.\d{0,2})?$/,
    maxLength: null,
  },
  {
    label: '研发投入强度(%)',
    required: true,
    placeholder: '请输入研发投入金额占企业收入的比重',
    tip: '研发投入强度(%)，可保留两位小数',
    type: 'input',
    value: null,
    key: 'strength',
    reg: /^(-)?\d+(\.\d{0,2})?$/,
    maxLength: null,
  },
  {
    label: '有效发明专利数',
    required: true,
    placeholder: '请输入企业有效发明专利数',
    tip: '有效发明专利数，可保留两位小数（可填0）',
    type: 'input',
    value: null,
    key: 'patent',
    reg: /^(0|[1-9]\d*)$/,
    maxLength: null,
  },
  {
    label: '其他知识产权数量',
    required: true,
    placeholder: '含实用新型和外观设计专利等',
    tip: '其他知识产权数量，可保留两位小数（可填0）',
    type: 'input',
    value: null,
    key: 'knowledge',
    reg: /^(0|[1-9]\d*)$/,
    maxLength: null,
  },
  {
    label: '申请享受加计扣除政策的研发费(万元)',
    required: true,
    placeholder: '请输入申请享受加计扣除政策的研发费',
    tip: '申请享受加计扣除政策的研发费(万元)，可保留两位小数（可填0）',
    type: 'input',
    value: null,
    key: 'policy_funds',
    reg: /^(0|[1-9]\d*)$/,
    maxLength: null,
  },
  {
    label: '就业人数 ',
    required: true,
    placeholder: '请输入社保缴纳人数',
    tip: '就业人数 ，可保留两位小数（可填0）',
    type: 'input',
    value: null,
    key: 'employment',
    reg: /^(0|[1-9]\d*)$/,
    maxLength: null,
  },
  {
    label: '企业在本地采购额占营业成本的比重(%)',
    required: true,
    placeholder: '请输入企业在本地采购额占营业成本的比重',
    tip: '企业在本地采购额占营业成本的比重(%)，保留两位小数（可填0）',
    type: 'input',
    value: null,
    key: 'purchase',
    reg: /^(0|[1-9]\d*)$/,
    maxLength: null,
  },
  {
    label: '2025企业纳税信用等级',
    required: true,
    placeholder: '请选择企业纳税信用等级',
    tip: '请选择2025企业纳税信用等级',
    type: 'select',
    value: undefined,
    key: 'credit',
    reg: null,
    maxLength: null,
    options: ['A级', 'B级', 'C级', 'D级', 'M级'],
  },
  {
    label: '实际引入重庆投资（万元）',
    required: false,
    placeholder: '请输入实际引入重庆投资(选填)',
    tip: '',
    type: 'input',
    value: null,
    key: 'investment',
    reg: null,
    maxLength: null,
  },
  {
    label: '形成行业或国家标准数',
    required: true,
    placeholder: '请输入主导制定或参与制定国家标准或行业标准数，并做详细说明',
    tip: '请输入主导制定或参与制定国家标准或行业标准数，并做详细说明',
    type: 'input',
    value: null,
    key: 'standard',
    reg: null,

    maxLength: null,
  },
  {
    label: '企业地址',
    required: true,
    placeholder: '请输入企业详细地址',
    tip: '请输入企业详细地址',
    type: 'input',
    value: null,
    key: 'address',
    reg: null,
    maxLength: 50,
  },
  {
    label: '企业注册时间',
    required: true,
    placeholder: '请输入企业注册时间（如：2015年8月）',
    tip: '请输入企业注册时间（如：2015年8月）',
    type: 'input',
    value: null,
    key: 'time',
    reg: null,
    maxLength: null,
  },
  {
    label: '企业注册地址',
    required: true,
    placeholder: '请输入企业注册所在区县',
    tip: '请输入企业注册所在区县',
    type: 'input',
    value: null,
    key: 'place',
    reg: null,
    maxLength: null,
  },
  {
    label: '联系人',
    required: true,
    placeholder: '请输入联系人姓名',
    tip: '请输入联系人姓名',
    type: 'input',
    value: null,
    key: 'contacts',
    reg: null,
    maxLength: 50,
  },
  {
    label: '联系人手机',
    required: true,
    placeholder: '请输入联系人手机号码',
    tip: '请输入联系人手机号码',
    type: 'input',
    value: null,
    key: 'conPhone',
    reg: /^1[345789][0-9]{9}$/,
    maxLength: 11,
  },
  {
    label: '邮箱',
    required: true,
    placeholder: '请输入联系人邮箱地址',
    tip: '请正确输入联系人邮箱地址',
    type: 'input',
    value: null,
    key: 'email',
    reg1: /^([a-zA-Z]|[0-9])(\w|-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
    reg2: /(?:[0-9a-zA-Z_]+.)+@[0-9a-zA-Z]{1,13}\.[com,cn,net]{1,3}/,
    maxLength: null,
  },
  {
    label: '参评理由',
    required: true,
    placeholder: '200字以内，简要描述参评人最具竞争力的优势',
    tip: '请输入参评理由',
    type: 'textarea',
    value: null,
    key: 'reason',
    reg: null,
    maxLength: null,
  },
  {
    label: '参评奖项',
    required: true,
    placeholder: '',
    tip: '请选择参评奖项',
    type: 'radio',
    value: 1,
    key: 'awards',
    reg: null,
    maxLength: null,
    options: [
      { label: '2026十大渝商', value: 1 },
      { label: '2026十大青年渝商', value: 2 },
      { label: '20年渝商特别贡献奖', value: 3 },
    ],
  },
  {
    label: '经济贡献力',
    required: true,
    placeholder:
      '参评人及所在企业为重庆经济社会发展做出的贡献，包括对地区生产总值的影响、税金缴纳、带动产业链发展、带动就业、提高人均可支配收入等方面做出的积极贡献，在推动外部投资、带动产业落地、促进区域合作等方面的实际成效。',
    tip: '请输入经济贡献力',
    type: 'textarea',
    value: null,
    key: 'contribution',
    reg: null,
    maxLength: null,
  },
  {
    label: '创新变革力',
    required: true,
    placeholder:
      '参评人及所在企业在推动新兴产业发展、科技创新、制度创新、推动数字化改革方面取得的成绩和亮点工作。如推动人工智能赋能千行百业；在科技成果转化应用等方面取得的成果，以及在整合科技创新资源，引领发展战略性新兴产业和未来产业；生产组织、产品技术、市场营销、制度管理等方面做出的创新；关注数字创新，注重数字经济与实体经济相融相促。推动产业模式和企业形态的根本性变革等方面的突出贡献等。',
    tip: '请输入创新变革力',
    type: 'textarea',
    value: null,
    key: 'innovate',
    reg: null,
    maxLength: null,
  },
  {
    label: '行业带动力',
    required: true,
    placeholder:
      '参评人及所在企业在国内或国际行业的引领性作用，如参与制定国家和行业标准；完成有较大行业影响力和带动力的项目；对推动行业发展做出切实贡献，为行业“智改数转”起到引领和示范作用。',
    tip: '请输入行业带动力',
    type: 'textarea',
    value: null,
    key: 'industrydrive',
    reg: null,
    maxLength: null,
  },
  {
    label: '持续发展力',
    required: true,
    placeholder:
      '参评人及所在单位在战略规划、组织架构、产品升级、人才资源、财务管理、企业文化、安全生产等方面，建立有长效发展机制，个人和企业具有较高的成长性、代表未来产业方向，持续发展后劲足。成功获得知名投资机构风险投资，且估值增长等情况。',
    tip: '请输入持续发展力',
    type: 'textarea',
    value: null,
    key: 'continued',
    reg: null,
    maxLength: null,
  },
  {
    label: '社会影响力',
    required: true,
    placeholder:
      '参评人及所在企业吸纳就业情况；在乡村振兴、节能减排、生态环保、公益慈善等方面，积极践行社会责任，为低碳绿色发展等方面做出的重要贡献。',
    tip: '请输入社会影响力',
    type: 'textarea',
    value: null,
    key: 'society',
    reg: null,
    maxLength: null,
  },
  {
    label: '上传照片',
    required: false,
    placeholder: '',
    tip: '请上传照片',
    type: 'image',
    value: null,
    key: 'cover',
    reg: null,
    maxLength: null,
  },
];
